var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloverHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29300",
    "data-name": "Group 29300",
    transform: "translate(-1235.861 10998.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1235.861 -10998.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29299",
    "data-name": "Group 29299",
    transform: "translate(1014.583 -11303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49726",
    "data-name": "Path 49726",
    d: "M66.894,10.823A8.435,8.435,0,0,0,62.1,8.775a8.432,8.432,0,0,0,4.769-2.046,2.446,2.446,0,0,0,0-3.459,2.529,2.529,0,0,0-1.659-.642.267.267,0,0,1-.25-.25,2.533,2.533,0,0,0-.643-1.66,2.446,2.446,0,0,0-3.459,0,8.444,8.444,0,0,0-2.06,4.93,8.444,8.444,0,0,0-2.06-4.93,2.446,2.446,0,0,0-3.459,0,2.533,2.533,0,0,0-.643,1.66.267.267,0,0,1-.25.25,2.529,2.529,0,0,0-1.659.642,2.444,2.444,0,0,0,0,3.459,8.433,8.433,0,0,0,4.779,2.047,8.433,8.433,0,0,0-4.779,2.047,2.446,2.446,0,0,0,0,3.459,2.529,2.529,0,0,0,1.659.642.267.267,0,0,1,.25.25,2.533,2.533,0,0,0,.643,1.66,2.446,2.446,0,0,0,3.459,0,8.041,8.041,0,0,0,1.6-2.761A21.026,21.026,0,0,0,59.514,18.4a7.312,7.312,0,0,0,1.931,2.867,4.923,4.923,0,0,0,.661.511.569.569,0,1,0,.6-.964,3.8,3.8,0,0,1-.5-.393A6.168,6.168,0,0,1,60.58,18a21.9,21.9,0,0,1-.892-2.963,7.468,7.468,0,0,0,1.2,1.792,2.446,2.446,0,0,0,3.459,0,2.529,2.529,0,0,0,.642-1.659.267.267,0,0,1,.25-.25,2.533,2.533,0,0,0,1.66-.643,2.446,2.446,0,0,0,0-3.459Zm-6.748-2.01a1.478,1.478,0,0,0-1.273,1.273q-.042.321-.061.645-.019-.324-.061-.645a1.478,1.478,0,0,0-1.273-1.273c-.112-.015-.223-.027-.332-.037.11-.01.22-.022.332-.037a1.476,1.476,0,0,0,1.013-.61l0,0a1.474,1.474,0,0,0,.256-.658c.022-.165.038-.328.05-.489.012.161.028.323.05.489a1.478,1.478,0,0,0,1.273,1.273c.116.015.23.028.344.038C60.363,8.787,60.255,8.8,60.147,8.813Z",
    transform: "translate(188.984 310.998)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49727",
    "data-name": "Path 49727",
    d: "M246.8,274.319a.569.569,0,0,1-.784.18,4.9,4.9,0,0,1-.661-.511,7.312,7.312,0,0,1-1.931-2.867,23.777,23.777,0,0,1-.92-3.011,10.888,10.888,0,0,1-.342-3.579.569.569,0,0,1,1.136.062c0,.061-.285,2.087,1.117,5.927.024.067.049.134.074.2a6.167,6.167,0,0,0,1.626,2.42,3.832,3.832,0,0,0,.5.393.569.569,0,0,1,.18.784Z",
    transform: "translate(5.07 58.281)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49728",
    "data-name": "Path 49728",
    d: "M244.419,270.521a8.7,8.7,0,0,1-1.4-3.293.147.147,0,0,0-.288,0,8.573,8.573,0,0,1-.223.883,10.887,10.887,0,0,1-.342-3.579.569.569,0,0,1,1.136.062C243.3,264.655,243.017,266.681,244.419,270.521Z",
    transform: "translate(5.071 58.28)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49729",
    "data-name": "Path 49729",
    d: "M255.221,7.465a1.478,1.478,0,0,0,1.273,1.273,8.527,8.527,0,0,0,6.747-2.01,2.446,2.446,0,0,0,0-3.459,2.529,2.529,0,0,0-1.659-.642.267.267,0,0,1-.25-.25,2.532,2.532,0,0,0-.643-1.66,2.446,2.446,0,0,0-3.459,0A8.527,8.527,0,0,0,255.221,7.465Z",
    transform: "translate(-7.384 310.998)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49730",
    "data-name": "Path 49730",
    d: "M261.422,2.562l-5.947,5.56h0a1.474,1.474,0,0,1-.256-.658,8.528,8.528,0,0,1,2.01-6.748A2.446,2.446,0,0,1,260.5.545a2.5,2.5,0,0,1,.191.172,2.533,2.533,0,0,1,.643,1.66.262.262,0,0,0,.092.186Z",
    transform: "translate(-7.382 310.999)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49731",
    "data-name": "Path 49731",
    d: "M58.753,7.465a1.473,1.473,0,0,1-.256.658l0,0a1.476,1.476,0,0,1-1.013.61,8.527,8.527,0,0,1-6.747-2.01,2.444,2.444,0,0,1,0-3.459,2.529,2.529,0,0,1,1.659-.642.267.267,0,0,0,.25-.25,2.533,2.533,0,0,1,.643-1.66,2.446,2.446,0,0,1,3.459,0A8.528,8.528,0,0,1,58.753,7.465Z",
    transform: "translate(188.983 310.998)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49732",
    "data-name": "Path 49732",
    d: "M65.088,7.465a1.473,1.473,0,0,1-.256.658l0,0a9.832,9.832,0,0,1-7.368-2.48,2.969,2.969,0,0,1-.826-1.793,2.442,2.442,0,0,1,.434-.586,2.529,2.529,0,0,1,1.659-.642.267.267,0,0,0,.25-.25,2.533,2.533,0,0,1,.643-1.66,2.446,2.446,0,0,1,3.459,0A8.528,8.528,0,0,1,65.088,7.465Z",
    transform: "translate(182.649 310.998)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49733",
    "data-name": "Path 49733",
    d: "M115.521,7.465a1.473,1.473,0,0,1-.256.658l-5.948-5.56a.262.262,0,0,0,.092-.186,2.532,2.532,0,0,1,.643-1.66,2.446,2.446,0,0,1,3.459,0A8.528,8.528,0,0,1,115.521,7.465Z",
    transform: "translate(132.216 310.998)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49734",
    "data-name": "Path 49734",
    d: "M268.879,14.657l-5.947,5.56a10.794,10.794,0,0,1,2.65-6.668,3.113,3.113,0,0,1,2.37-.909,2.5,2.5,0,0,1,.191.172,2.533,2.533,0,0,1,.643,1.66A.263.263,0,0,0,268.879,14.657Z",
    transform: "translate(-14.839 298.904)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49735",
    "data-name": "Path 49735",
    d: "M256.986,204.6a1.477,1.477,0,0,0-1.273,1.273,8.528,8.528,0,0,0,2.01,6.747,2.446,2.446,0,0,0,3.459,0,2.529,2.529,0,0,0,.642-1.659.267.267,0,0,1,.25-.25,2.532,2.532,0,0,0,1.66-.643,2.446,2.446,0,0,0,0-3.459A8.528,8.528,0,0,0,256.986,204.6Z",
    transform: "translate(-7.854 115.208)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49736",
    "data-name": "Path 49736",
    d: "M277.38,210.8l-5.56-5.947h0a1.474,1.474,0,0,1,.658-.256,8.528,8.528,0,0,1,6.748,2.01,2.446,2.446,0,0,1,.172,3.267,2.5,2.5,0,0,1-.172.191,2.533,2.533,0,0,1-1.66.643A.262.262,0,0,0,277.38,210.8Z",
    transform: "translate(-23.347 115.211)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49737",
    "data-name": "Path 49737",
    d: "M277.39,218.261l-5.56-5.947a10.794,10.794,0,0,1,6.668,2.65,3.113,3.113,0,0,1,.909,2.37,2.485,2.485,0,0,1-.172.191,2.533,2.533,0,0,1-1.66.643A.262.262,0,0,0,277.39,218.261Z",
    transform: "translate(-23.356 107.753)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49738",
    "data-name": "Path 49738",
    d: "M58.751,205.872a1.478,1.478,0,0,0-1.273-1.273,8.527,8.527,0,0,0-6.747,2.01,2.446,2.446,0,0,0,0,3.459,2.529,2.529,0,0,0,1.659.642.267.267,0,0,1,.25.25,2.533,2.533,0,0,0,.643,1.66,2.446,2.446,0,0,0,3.459,0A8.528,8.528,0,0,0,58.751,205.872Zm.867-.123c.043-.144.078-.211.06-.071A.079.079,0,0,1,59.618,205.749Z",
    transform: "translate(188.985 115.213)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49739",
    "data-name": "Path 49739",
    d: "M109.321,226.266l5.947-5.56h0a1.474,1.474,0,0,1,.256.658,8.528,8.528,0,0,1-2.01,6.747,2.446,2.446,0,0,1-3.267.172,2.485,2.485,0,0,1-.191-.172,2.533,2.533,0,0,1-.643-1.66A.262.262,0,0,0,109.321,226.266Z",
    transform: "translate(132.212 99.72)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49740",
    "data-name": "Path 49740",
    d: "M109.321,226.276l5.947-5.56a10.793,10.793,0,0,1-2.65,6.668,3.113,3.113,0,0,1-2.37.909,2.5,2.5,0,0,1-.191-.172,2.533,2.533,0,0,1-.643-1.66A.262.262,0,0,0,109.321,226.276Z",
    transform: "translate(132.212 99.71)",
    fill: "#5eac24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloverHighlighted);
export default __webpack_public_path__ + "static/media/cloverHighlighted.948f35d9f9e0b6d907157e92088cf9ef.svg";
export { ForwardRef as ReactComponent };